export default function(value, currency, fix = 0) {
  const val = value || 0;

  if (!currency) {
    return new Intl.NumberFormat(undefined, { minimumFractionDigits: fix }).format(val);
  }

  return new Intl.NumberFormat(undefined, {
    currency,
    style: 'currency',
    minimumFractionDigits: fix,
  }).format(val);
}
